/*
 * @Author: yyl
 * @Date: 2025-06-25 14:06:13
 * @LastEditTime: 2025-06-26 10:26:23
 * @LastEditors: yyl
 * @Description: 
 * @FilePath: /bolimao/Users/bolimao/Desktop/A-类私有云的项目/下关中学/xiaguan-schools-website/src/api/home.js
 * 可以输入预定的版权声明、个性签名、空行等
 */
// src/api/home.js
import request from '@/utils/request'

// 获取学校简介数据
export function getSchoolIntro() {
  return request({
    url: '/home/common',
    method: 'get',
  })
}

export function getHomeIntro() {
  return request({
    url: '/home/index',
    method: 'get',
  })
}

export function fetchListData(data) {
  return request({
    url: '/home/listIndex',
    method: 'get',
    params: data
  })
}


export function fetchDetailData(data) {
  return request({
    url: '/home/show',
    method: 'get',
    params: data
  })
}